export const trainings = [
  {
    id: "hammamet-2026",
    slug: "hammamet-2026",
    title:
      "Tools for shifting narratives and increasing sensitivity to diversity: The DCA Training in Hammamet, Tunisia",
    date: "March 22-31, 2026",
    location: "Hammamet, Tunisia",
    featuredImage:
      "/images/dca/Hammamet%20Tunisia/DCA%20Post-09.jpg",
    imageContain: true,
    excerpt:
      "From 22 to 31 March 2026, the Mediterranean coast of Nabeul provided the backdrop for an extraordinary learning experience: the second international training course of the DCA – Differences Challenge Assumptions project.",
    facilitators: [
      {
        name: "Andreea-Loredana Tudorache",
        role: "Facilitator",
      },
      {
        name: "Elena Stevkovska",
        role: "Facilitator",
      },
    ],
    sections: [
      {
        text: "From 22 to 31 March 2026, the Mediterranean coast of Nabeul provided the backdrop for an extraordinary learning experience: the second international training course of the DCA – Differences Challenge Assumptions project, a transnational initiative co-funded by the Erasmus+ Programme of the European Union, which brought together young youth workers from seven countries across Europe and the Mediterranean. The event was organized by A.R.T Fusion Association and hosted by the organization EUROMED EVE Tunisia.",
        image: "/images/dca/Hammamet%20Tunisia/DCA%20Post-09.jpg",
        imageAlt: "DCA Training Course in Hammamet, Tunisia",
        imagePosition: "right",
      },
      {
        text: "At the heart of the training's methodology were two highly experienced facilitators who created a learning space that was safe and stimulating. Together, they worked to challenge assumptions one step at a time — using role plays, simulations, collective reflection sessions and intercultural group work to turn the training into a lived experience rather than something simply transmitted.",
        image: "/images/dca/Hammamet%20Tunisia/DCA%20Post-07.jpg",
        imageAlt: "Facilitators leading the DCA training session",
        imagePosition: "left",
      },
      {
        text: "Ten days on the Mediterranean, seven cultures in dialogue, an Erasmus+ project bold enough to challenge what we take for granted. The DCA training course in Nabeul was far more than a programme of workshops and sessions. It was a space where young workers from vastly different backgrounds learned to look beyond their own assumptions, to ask uncomfortable questions, and to build together something more solid than any prejudice.",
        image: "/images/dca/Hammamet%20Tunisia/DCA%20Post-06.jpg",
        imageAlt: "Participants engaging in intercultural dialogue",
        imagePosition: "right",
      },
      {
        text: "This second training course represents another solid and strong milestone in the DCA project's journey. The experience reaffirmed the consortium's commitment to fostering equality, empathy, and social awareness across all partner organizations — building a collective voice that challenges biases and inspires systemic change.",
        image: "/images/dca/Hammamet%20Tunisia/DCA%20Post-02.jpg",
        imageAlt: "Group photo of DCA training participants in Tunisia",
        imagePosition: "left",
      },
    ],
    images: [
      "/images/dca/Hammamet%20Tunisia/DCA%20Post-02.jpg",
      "/images/dca/Hammamet%20Tunisia/DCA%20Post-06.jpg",
      "/images/dca/Hammamet%20Tunisia/DCA%20Post-07.jpg",
      "/images/dca/Hammamet%20Tunisia/DCA%20Post-09.jpg",
    ],
  },
  {
    id: "romania-2025",
    slug: "romania-2025",
    title:
      "Challenging Narratives, Embracing Diversity: The DCA Training Course in Bușteni, Romania",
    date: "August 22-31, 2025",
    location: "Bușteni, Romania",
    featuredImage: "/images/romania-training/IMG_1239.JPG",
    imageContain: true,
    excerpt:
      'From August 22 to 31, 2025, youth workers from across Europe gathered in Bușteni, Romania, for the first training course under the "Differences – Assumptions – Challenge (DCA)" project.',
    facilitators: [
      {
        name: "Andreea-Loredana Tudorache",
        role: "Facilitator",
      },
      {
        name: "Elena Stevkovska",
        role: "Facilitator",
      },
    ],
    sections: [
      {
        text: 'From August 22 to 31, 2025, youth workers from across Europe gathered in Bușteni, Romania, for the first training course under the "Differences – Assumptions – Challenge (DCA)" project — a long-term initiative dedicated to exploring Diversity, Intersectionality, and Narratives.',
        image: "/images/romania-training/IMG_1239.JPG",
        imageAlt: "DCA Training Course in Romania",
        imagePosition: "right",
      },
      {
        text: "Organized by A.R.T. Fusion Association, the training marked the beginning of an inspiring journey that aims to challenge mainstream narratives and social paradigms surrounding diversity, equality, and inclusion. Participants from partner organizations across various countries joined forces to build deeper understanding, self-awareness, and critical reflection on how biases shape our societies and influence the way we perceive others.",
        image: "/images/romania-training/20250823_122157.jpg",
        imageAlt: "Training activities and workshops",
        imagePosition: "left",
      },
      {
        text: "Over the course of eight intensive days, the program combined non-formal education methods and experiential learning activities, creating a safe and engaging environment where participants could examine their own assumptions and explore intersectional perspectives. Sessions focused on identifying and deconstructing dominant discourses while encouraging youth workers to find inclusive approaches to representation and storytelling in their communities.",
        image: "/images/romania-training/20250825_161104.jpg",
        imageAlt: "Participants collaborating during training",
        imagePosition: "right",
      },
      {
        text: "The training was facilitated by Andreea-Loredana Tudorache and Elena Stevkovska, who brought their extensive experience in human rights education, social inclusion, and diversity to guide the learning process. Their approach emphasized active participation, emotional intelligence, and critical dialogue — helping participants translate theoretical understanding into practical strategies for change.",
        image: "/images/romania-training/IMG_1242.JPG",
        imageAlt: "Group photo of training participants",
        imagePosition: "left",
      },
      {
        text: "Set in the heart of the Carpathian Mountains, the venue in Bușteni offered not only a beautiful natural backdrop but also the perfect setting for reflection and intercultural connection. Participants shared experiences, cultures, and ideas through collaborative learning and an international evening that celebrated unity in diversity.",
        imagePosition: "center",
      },
      {
        text: "This training course represents a first milestone in the DCA project's long-term effort to reshape narratives and promote inclusive thinking within youth work and beyond. The experience reaffirmed the consortium's commitment to fostering equality, empathy, and social awareness across all partner organizations — building a collective voice that challenges biases and inspires systemic change.",
        imagePosition: "center",
      },
    ],
    images: [
      "/images/romania-training/20250823_122157.jpg",
      "/images/romania-training/20250823_122225.jpg",
      "/images/romania-training/20250825_161104.jpg",
      "/images/romania-training/20250825_161246.jpg",
      "/images/romania-training/IMG_1239.JPG",
      "/images/romania-training/IMG_1242.JPG",
      "/images/romania-training/IMG_20250829_190350.jpg",
      "/images/romania-training/WhatsApp Image 2025-08-25 at 2.27.08 PM.jpeg",
      "/images/romania-training/WhatsApp Image 2025-08-28 at 6.01.42 PM.jpeg",
      "/images/romania-training/WhatsApp Image 2025-08-28 at 7.03.07 PM.jpeg",
    ],
  },
];
